module.exports = __webpack_public_path__ + "img/category-casino-hover.2be2d2eb.png";